import { render, staticRenderFns } from "./AddRepairs.vue?vue&type=template&id=62f87221"
import script from "./AddRepairs.vue?vue&type=script&lang=js"
export * from "./AddRepairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports